// utils/geo.js

// Haversine distance
export function getDistance([lng1, lat1], [lng2, lat2], unit = "miles") {
    const toRad = (value) => (value * Math.PI) / 180;

    const R_KM = 6371;
    const R_MI = 3958.8;

    const R = unit === "km" ? R_KM : R_MI;

    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

export function sortStoresByDistance(userCoords, stores, unit = "miles") {
    return stores
        .map((store) => ({
            ...store,
            distance: getDistance(userCoords, store.coordinates, unit),
        }))
        .sort((a, b) => a.distance - b.distance);
}

export function getNearestStores(
    userCoords,
    stores,
    limit = 10,
    unit = "miles"
) {
    return sortStoresByDistance(userCoords, stores, unit).slice(0, limit);
}